export function Footer() {
  return (
    <footer className="bg-dark-300 border-t border-gray-800 py-8">
      <div className="container mx-auto px-4">
        <div className="text-center">
          <p className="text-gray-400 text-sm mb-2">
            © 2025 AnimeTine. All rights reserved. This is a demo project.
          </p>
          <p className="text-gray-500 text-xs">
            Powered by AniList API. AnimeTine is not affiliated with or endorsed by AniList.
          </p>
        </div>
      </div>
    </footer>
  )
}
